export const TITLE = 'Max Points for this Question';
export const PLACEHOLDER = '1';
